import React from "react";

const LoginLogo = () => {
  return (
    <div className="flex w-fit items-center gap-2  rounded-md bg-white py-0.5">
      <img
        src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811"
        loading="eager"
        alt=""
        className="h-[1.75rem] w-[1.75rem]"
      />
      <p className="text-md font-medium text-black">LearnTube.ai</p>
    </div>
  );
};

export default LoginLogo;
